import type { Product, TaskId } from "../registry/types";

export const WALKTHROUGH_SETUP_TASK_COMPLETED_SIGNAL =
  "walkthrough-setup-task-completed";

export interface WalkthroughSetupTaskCompletedPayload {
  product: Product;
  taskId: TaskId;
}

export function isWalkthroughSetupTaskCompletedPayload(
  payload: unknown,
): payload is WalkthroughSetupTaskCompletedPayload {
  if (!payload || typeof payload !== "object") {
    return false;
  }
  const candidate = payload as Partial<WalkthroughSetupTaskCompletedPayload>;
  return (
    typeof candidate.product === "string" &&
    typeof candidate.taskId === "string"
  );
}
